// This class hides the details of the favorite product logic (cache implementation, logged in vs not logged in, etc.) from the rest of the application.
export abstract class FavoriteProductManager {
  abstract isFavoriteProduct(
    handle: string,
    variantId: string | null,
  ): Promise<boolean>;

  abstract addFavoriteProductWithDefaultVariant(
    handle: string,
    variantId: string | null,
  ): Promise<void>;

  abstract removeFavoriteProduct(
    handle: string,
    variantId: string | null,
  ): Promise<void>;

  abstract isLoggedIn(): boolean;
}
